// src/utils/categoryColors.js

const colorOptions = [
  'default',
  'primary',
  'secondary',
  'error',
  'warning',
  'info',
  'success',
];

/**
 * Asigna un color basado en el nombre de la categoría.
 * @param {string} categoryName - Nombre de la categoría.
 * @returns {string} - Nombre del color de Material-UI.
 */
export const getColorForCategory = (categoryName) => {
  let hash = 0;
  for (let i = 0; i < categoryName.length; i++) {
    hash = categoryName.charCodeAt(i) + ((hash << 5) - hash);
  }
  const index = Math.abs(hash) % colorOptions.length;
  return colorOptions[index];
};
